import { Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { NetworkStatusBanner } from '@antimatterhq/ui/components/networkStatusBanner';
import { useAtomValue } from 'jotai';
import { useDataDog } from '@/hooks/datadog/useDataDog';
import { useParentDarkModeSync } from '@/hooks/iframe/useParentDarkModeSync';
import { useParentRouteHandler } from '@/hooks/iframe/useParentRouteHandler';
import { networkStatusAtom } from '@/atoms/networkStatus/networkStatusAtoms';

const ClientNetworkStatusBanner = () => {
  const networkStatus = useAtomValue(networkStatusAtom);
  return <NetworkStatusBanner status={networkStatus} />;
};

export default function Root() {
  useParentRouteHandler();
  useParentDarkModeSync();
  useDataDog();

  return (
    <>
      <ClientNetworkStatusBanner />
      <div className="flex h-screen w-full flex-col overflow-hidden">
        <Outlet />
      </div>
      <Toaster position="bottom-right" />
    </>
  );
}
